import { DayWorkingHour, Identifiable, ObjectValue } from './common.model';
import { FeedbackStatsEntity } from './feedback.model';

export type BusinessInformationEntity = {
  holidayHours: {
    id: string;
    date: string;
    name: string;
    closed: boolean;
  }[];
  dayOffHours: {
    date: string;
    close: string;
    open: string;
  }[];
  workingHours: {
    monday: DayWorkingHour;
    tuesday: DayWorkingHour;
    wednesday: DayWorkingHour;
    thursday: DayWorkingHour;
    friday: DayWorkingHour;
    saturday: DayWorkingHour;
    sunday: DayWorkingHour;
  };
  address: string;
  address2: string;
  city: string;
  phoneNumber: string;
  storeLogo: string;
  storeName: string;
  state: string;
  website: string;
  zipCode: string;
  description: string;
  type: StoreType[];
  galleryPhotos: string[];
  banner: string;
  maxStaffCount: number;
  email?: string;
  smsPhoneNumber?: string;
  latitude: number;
  longitude: number;
  storeStats?: FeedbackStatsEntity;
} & Identifiable;
export const storeTypes = {
  nail: 'nail',
  spa: 'spa',
  pets: 'pets',
  waxing: 'waxing',
  hair: 'hair',
  tattoo: 'tattoo',
} as const;

export type StoreType = ObjectValue<typeof storeTypes>;
